module.exports = __webpack_public_path__ + "img/aj-1980web.a07c5b33.jpg";